

import { api, tempApi } from './api';
import { setToken } from '../utils/auth';

export const businessAuthService = {
  // Business login uses the encrypted username/email blind index server-side.
  businessLogin: async (username, password) => {
    console.log('🔑 [BUSINESS AUTH] Sending login to /api/business/login');
    
    try {
      const response = await tempApi.post('/api/business/login', {
        username,
        password,
      });

      console.log('✅ [BUSINESS AUTH] Login API response received');
      
      const { token, requiresPasswordChange, tempToken, business } = response.data;

      localStorage.setItem("authType",business.authType)
      localStorage.setItem("industry",business.industry)

     
      // Determine which token to use
      let actualToken = null;
      
       if (!requiresPasswordChange && actualToken) {
      setToken(actualToken, 'business');
      }
      
      if (requiresPasswordChange) {
        console.log('🔄 [BUSINESS AUTH] Password change required, using tempToken');
        actualToken = tempToken;
      } else {
        console.log('✅ [BUSINESS AUTH] Regular login, using token');
        actualToken = token;
      }

      if (!actualToken && !requiresPasswordChange) {
        console.error('❌ [BUSINESS AUTH] No token for regular login!');
        throw new Error('No authentication token received');
      }

      return { 
        success: true, 
        requiresPasswordChange,
        token: actualToken,
        business 
      };
    } catch (error) {
      console.error('❌ [BUSINESS AUTH] Login API error:', error.response?.data || error.message);
      
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Business login failed',
      };
    }
  },

  // Change password with temp token (first login)
  changePasswordWithTempToken: async (tempToken, oldPassword, newPassword, confirmPassword) => {
    console.log('🔑 [BUSINESS AUTH] Changing password with temp token');
    
    try {
      const response = await tempApi.put(
        '/api/business/change-password',
        {
          oldPassword,
          newPassword,
          confirmPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${tempToken}`,
          },
        }
      );

      console.log('✅ [BUSINESS AUTH] Password change successful:', response.data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('❌ [BUSINESS AUTH] Password change error:', error.response?.data || error.message);
      
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to change password',
      };
    }
  },

  // Change password with regular token (after first login)
  changePassword: async (oldPassword, newPassword, confirmPassword) => {
    console.log('🔑 [BUSINESS AUTH] Changing password with regular token');
    
    try {
      const response = await api.put('/api/business/change-password', {
        oldPassword,
        newPassword,
        confirmPassword,
      });

      console.log('✅ [BUSINESS AUTH] Regular password change successful:', response.data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('❌ [BUSINESS AUTH] Regular password change error:', error.response?.data || error.message);
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to change password',
      };
    }
  },

  // Get business profile
  getBusinessProfile: async () => {
    console.log('📊 [BUSINESS AUTH] Fetching business profile...');
    
    try {
      const response = await api.get('/api/business/profile');
      console.log('✅ [BUSINESS AUTH] Business profile fetched');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('❌ [BUSINESS AUTH] Business profile error:', error.response?.data || error.message);
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to fetch business profile',
      };
    }
  },

  // Get business dashboard
  getBusinessDashboard: async () => {
    console.log('📊 [BUSINESS AUTH] Fetching business dashboard...');
    
    try {
      const response = await api.get('/api/business/dashboard');
      console.log('✅ [BUSINESS AUTH] Business dashboard fetched');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('❌ [BUSINESS AUTH] Business dashboard error:', error.response?.data || error.message);
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to fetch dashboard data',
      };
    }
  },
  
// Add this ONE function to existing businessAuth.js
  getBusinessTransactions: async (businessId, event = null, page = 1, limit = 10) => {
  console.log('💳 [BUSINESS AUTH] Fetching transactions for business:', businessId);
  
  try {
    const params = {
      page,
      limit
    };
    
    // Add event if provided (and not 'ALL')
    if (event && event !== 'ALL') {
      params.event = event;
    }

    
    console.log('📤 Sending params:', params);
    
    // Use GET request with URL params
    const response = await api.get('/api/transactions', { params });
    console.log('✅ Transactions API response:', response.data);
    
    if (response.data.success) {
  return {
    success: true,
    data: response.data.data,
    pagination: response.data.pagination
  };
}
    
    return {
      success: false,
      error: response.data.message || 'Failed to fetch transactions'
    };
  } catch (error) {
    console.error('❌ Get transactions error:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    
    return {
      success: false,
      error: error.response?.data?.message || error.message || 'Failed to fetch transactions'
    };
  }
},
};